import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './task.types';

export const taskSelectors = {
  ...generateResourceSelectors<types.ITask>((state) => state.resource.task),
};
